import { faCalendarPlus, faChevronDown, faChevronUp, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chance } from 'chance';
import moment from 'moment/moment';
import { Component } from 'react';
import { Button, Container, Image, Spinner } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import { connect } from 'react-redux';
import { POST } from '../../api/index';
import { Black, BlueCrayola, CerisePink, CyanProcess, FrenchRose, Gray, LightSilver, SpanishGray, White, WhiteMarble } from '../../helpers/brand_colors_helper';
import { withParams } from '../../helpers/params_helper';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import { t } from '../../helpers/translation_helper';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import AcademicActivityReflection from '../Dashboard/AcademicActivityReflection';
import GetIcon from '../../helpers/icon_helper';
import { trimThisDown } from '../../helpers/general_helpers';
const chance = new Chance();

const apiURL = process.env.REACT_APP_API_URL;
const portalURL = process.env.REACT_APP_PORTAL_URL;

const defaultTimelineTypes = [
    {
        uid: chance.unique(chance.integer, 1, { min: 99999999999, max: 999999999999 })[0],
        label: "Activity",
        ut_type: "Academic Activity",
        picture: require('../../assets/images/user-timeline/activity.png'),
        active: true,
    },
]
/**
 * Activities Component
 */
class Activities extends Component {
    // State
    state = {
        getUserTimelineData: {
            refreshing: false,
            finished: false,
            limit: 12,
            offset: 0,
            data: [],
            totalRecords: 0,
        },
        filter: {
            show: false,
            toggleFilter: (show) => this.setState({ filter: { ...this.state.filter, show: (this.state.filter.show == show) ? false : show } }),
            setData: (key, value) => {
                this.setState({ filter: { ...this.state.filter, [key]: value } })
            },
            selectedUT: defaultTimelineTypes.map((v, i) => { return { label: v.name, value: v.ut_type } }),
            selectedDateRange: { startDate: new Date(moment().subtract(12, 'month')), endDate: new Date(), key: 'selection' },
            keyword: '',
        },
        academicActivityReflectionModal: {
            show: false,
            modalTitle: 'Assignment',
            data: null,
            closeModal: () => this.setState({ academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: false } }),
            toggleModal: (modalTitle = null, data = null) => this.setState({
                academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: !this.state.academicActivityReflectionModal.show, modalTitle, data }
            }),
            showModal: () => this.setState({ academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: true } }),
        },
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        this.refreshUserTimeline();
    }

    getUserTimeline = () => {

        const { authData, selectedChild } = this.props;
        const { class_id, child_id } = selectedChild;

        if (this.state.getUserTimelineData.refreshing) {
            return false
        }
        if (this.state.getUserTimelineData.finished) {
            return false
        }

        this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, refreshing: true } }, () => {

            if (this.getUserTimelineRequest) {
                this.getUserTimelineRequest.abort()
            }
            this.getUserTimelineRequest = new AbortController();

            let userTimelineDataLen = this.state.getUserTimelineData.data.length

            let fData = new FormData()
            fData.append('selectedTimelineTypes', JSON.stringify(this.state.filter.selectedUT.map((v, i) => { return { ut_type: v.value, active: true } })))
            fData.append('offset', (userTimelineDataLen > 0) ? this.state.getUserTimelineData.offset : 0)
            fData.append('limit', this.state.getUserTimelineData.limit)
            fData.append('user_id', this.props.authData.loginData.user_id)
            fData.append('child_id', child_id)
            fData.append('class_id', class_id)
            fData.append('center_id', this.props.authData.centerData.center_id)
            fData.append('center_timezone', this.props.authData.centerData.center_timezone)
            fData.append('ut_id', (userTimelineDataLen > 0) ? this.state.getUserTimelineData.data[userTimelineDataLen - 1].ut_id : 0)
            fData.append('activeFilterDateFrom', (this.state.filter.selectedDateRange.startDate) ? moment(this.state.filter.selectedDateRange.startDate).format('YYYY-MM-DD') + ' 00:00:00' : null)
            fData.append('activeFilterDateTo', (this.state.filter.selectedDateRange.endDate) ? moment(this.state.filter.selectedDateRange.endDate).format('YYYY-MM-DD') + ' 23:59:59' : null)


            POST('user-timeline', fData, {
                params: {
                    auth_key: this.props.authData.loginData.auth_key,
                },
                signal: this.getUserTimelineRequest.signal,
            })
                .then((res) => {
                    if (res) {
                        let resData = res.data
                        if (resData.length <= 0) {
                            this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, refreshing: false, finished: true, offset: this.state.getUserTimelineData.offset + this.state.getUserTimelineData.limit } })
                            return
                        }
                        this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, data: this.state.getUserTimelineData.data.concat(resData), refreshing: false, finished: false, offset: this.state.getUserTimelineData.offset + this.state.getUserTimelineData.limit } })
                    }
                })

        })

    }
    refreshUserTimeline = () => {
        this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, data: [], refreshing: false, finished: false, offset: 0 }, filter: { ...this.state.filter, show: false } }, () =>
            this.getUserTimeline()
        )
    }

    renderTile = (allData) => {
        const { getUserTimelineData, academicActivityReflectionModal } = this.state;
        let cardImage = (allData.academic_activities.aa_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activities/' + allData.academic_activities.aa_image : require('../../assets/images/noimage.png')

        return <div className='d-flex flex-column justify-content-between' key={this.props.key} style={{ width: 'calc(' + '25% - 20px)', backgroundColor: White, borderRadius: 20, margin: 10, position: 'relative', padding: 0, fontSize: 12 }}>
            <div style={{ padding: '1rem', height: '100%' }} className='d-flex flex-column justify-content-between'>
                <div>
                    <div className='d-flex flex-row justify-content-between align-items-start mb-2'>
                        <div style={{ flex: 1, fontWeight: '600' }}> {allData.ut_title}</div>
                        <div style={{ flex: 1 }} className='d-flex flex-row justify-content-end flex-wrap'>
                            {allData.academic_classmain_subject && allData.academic_classmain_subject.map((acs_v, acs_i) => {
                                return <div key={acs_i} style={{ backgroundColor: CyanProcess, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center ms-2 mb-1'>
                                    {acs_v.acs_name}
                                </div>
                            })}
                        </div>
                    </div>
                    <Image src={cardImage} style={{ objectFit: 'cover', width: '100%', height: '8rem', backgroundColor: White, borderRadius: '1rem' }} />
                    <div className='d-flex flex-row justify-content-between align-items-start mt-2 mb-1' style={{ fontSize: 11 }}>
                        <div className='d-flex flex-row' style={{ fontSize: 10, color: SpanishGray, }}>
                            <div className='me-2'>
                                <div style={{ color: LightSilver, fontSize: 8 }}>From</div>
                                <div>{moment(allData.start_datetime).format('DD-MM-YYYY')}</div>
                                <div>{moment(allData.start_datetime).format('HH:mm A')}</div>
                            </div>
                            <div>
                                <div style={{ color: LightSilver, fontSize: 8 }}>To</div>
                                <div>{moment(allData.end_datetime).format('DD-MM-YYYY')}</div>
                                <div>{moment(allData.end_datetime).format('HH:mm A')}</div>
                            </div>
                        </div>
                        <div style={{ backgroundColor: WhiteMarble, color: Black, borderRadius: 5, fontSize: 11, padding: '1px 2px' }} className='d-flex flex-row align-items-center'>
                            <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 10 }} />
                            {moment(allData.created_on).format('DD-MM-YYYY')}
                        </div>
                    </div>
                    {(allData.ut_description && allData.ut_description != 'null') && <div style={{ color: SpanishGray }}>{trimThisDown(allData.ut_description, 60)}</div>}
                </div>
                <div className='d-flex flex-row justify-content-between align-items-end mt-1'>
                    <div style={{ backgroundColor: CerisePink, color: White, borderRadius: 5, fontSize: 11, padding: '2px 3px' }} className='d-flex flex-row align-items-center'>
                        <div>Reflections</div>
                        <div className='text-center mx-1' style={{ minHeight: 10, minWidth: 15, borderRadius: 10, backgroundColor: White, color: Black, fontSize: 10 }}>{allData.academic_activity_reflections_new}</div>
                    </div>
                    <div className='d-flex flex-row align-items-center cursor-pointer' style={{ color: BlueCrayola, textDecoration: 'underline' }} onClick={() => academicActivityReflectionModal.toggleModal(allData.ut_title, allData)}>
                        <div className='me-1'>More Details</div>
                        <GetIcon icon="LuExternalLink" />
                    </div>
                </div>
            </div>
        </div>
    }

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        // Language Direction
        const { lang_orientation: dir } = this.props.defaultLanguage;

        // State
        const { getUserTimelineData, academicActivityReflectionModal } = this.state;

        return (
            <Container fluid>
                <div id='iedu-layout'>
                    <NavBar />
                    <div id='page-content'>
                        <Header lite={true} heading={'Activities'} backBtn={true} showChildSelector={true} func={[this.refreshUserTimeline]} />

                        {/* FILTER BAR */}
                        <div className="d-flex flex-row align-items-center mb-2">
                            {/* DATE */}
                            <div className="position-relative" style={{ flex: 1 }} >
                                <div className="px-3 py-1 d-flex flex-row align-items-center justify-content-between" style={{ border: 'solid 1px ' + LightSilver, borderRadius: 20 }} onClick={() => this.state.filter.toggleFilter('date_range_picker')}>
                                    <div className='d-flex flex-row align-content-center'>
                                        <div>
                                            <FontAwesomeIcon
                                                icon={(this.state.filter.show == 'date_range_picker') ? faChevronUp : faChevronDown}
                                                color={SpanishGray}
                                                className="filter-arrow"

                                            />
                                        </div>
                                        <div className="ms-1">{moment(this.state.filter.selectedDateRange.startDate).format('DD-MM-YYYY')} -- {moment(this.state.filter.selectedDateRange.endDate).format('DD-MM-YYYY')}</div>
                                    </div>
                                    <div>
                                        <GetIcon icon="LuCalendar" style={{ color: SpanishGray }} />
                                    </div>
                                </div>
                                {(this.state.filter.show == 'date_range_picker')
                                    && <div style={{ display: (this.state.filter.show == 'date_range_picker') ? 'initial' : 'none', position: 'absolute', top: 35, left: 0, zIndex: 1, border: 'solid 1px ' + LightSilver, borderRadius: 20, overflow: 'hidden' }}>
                                        <DateRangePicker
                                            ranges={[this.state.filter.selectedDateRange]}
                                            onChange={(date) => {
                                                this.state.filter.setData('selectedDateRange', { startDate: new Date(date.selection.startDate), endDate: new Date(date.selection.endDate), key: 'selection' })
                                            }}
                                            // className='filter-date-picker'
                                            style={{ backgroundColor: '#fff' }}
                                        />
                                    </div>
                                }
                            </div>
                            {/* BTN SEARCH */}
                            <div className="filter-btn d-flex align-items-center" style={{ marginLeft: 10 }}>
                                <Button size="sm" variant="primary" className='d-flex flex-row align-items-center' style={{ borderRadius: 40 }} onClick={() => {
                                    this.setState({ getUserTimelineData: { ...this.state.getUserTimelineData, data: [], refreshing: false, finished: false, offset: 0 }, filter: { ...this.state.filter, show: false } }, () =>
                                        this.getUserTimeline()
                                    )
                                }}>
                                    <div>
                                        {this.state.getUserTimelineData.refreshing
                                            ? <Spinner size='sm' animation='grow' variant='light' />
                                            : <GetIcon icon="LuSearch" style={{ fontSize: 16 }} />
                                        }
                                    </div>
                                    <div className='ms-1'>{t('Search')}</div>
                                </Button>
                            </div>
                        </div>

                        <div className='grey-section mb-0 p-0' style={{ height: '79vh', overflowY: 'auto' }}>
                            {getUserTimelineData.data.length > 0 ? (
                                <div className='d-flex flex-row flex-wrap p-1'>
                                    {getUserTimelineData.data.map((v, index) => {

                                        return this.renderTile(v)
                                    }
                                    )}
                                </div>
                            ) : (
                                null
                            )}
                            <div className="d-grid gap-2">
                                <div onClick={() => this.getUserTimeline()} className='p-3 cursor-pointer d-flex flex-row align-items-center justify-content-center' style={{ backgroundColor: White, width: '100%' }}>
                                    {getUserTimelineData.refreshing ? (
                                        <Spinner size='sm' animation='grow' variant='light' />
                                    ) : (
                                        <>
                                            {(getUserTimelineData.finished) ? t('No more activities found!') : t('Load More')}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ACADEMIC ACTIVITY REFLECTION MODAL */}
                <AcademicActivityReflection academicActivityReflectionModal={this.state.academicActivityReflectionModal} />
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
});
export default connect(mapStateToProps, null)(withParams(Activities));
